module.exports = "<div class=\"<%= wrap %>\">\r\n    <div class=\"<%= left %>\" ng-bind-html=\"match.model.code + ':' | gwTypeaheadHighlight:query\"></div>\r\n    <div class=\"<%= right %>\" ng-bind-html=\"match.model.classification | gwTypeaheadHighlight:query\"></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/typeahead/matchContentDirectives/PropertyCode/PropertyCode.html
// module id = 610
// module chunks = 0